import React, { Component } from "react";

import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Leadstages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      filteredData: null,

      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.leadstages_Id,

          sortable: true,

          cell: (row) => <span>{row.leadstages_Id}</span>,
        },

        {
          name: "Stage Id",

          selector: (row, i) => row.stageId,

          sortable: true,

          cell: (row) => <span>{row.stageId}</span>,
        },

        {
          name: "Stage Name",

          selector: (row, i) => row.stageName,

          sortable: true,

          cell: (row) => <span>{row.stageName}</span>,
        },

        {
          name: "Stage Order",

          selector: (row, i) => row.stageOrder,

          sortable: true,

          cell: (row) => <span>{row.stageOrder}</span>,
        },

        {
          name: "Stage Description",

          selector: (row, i) => row.stageDescription,

          sortable: true,

          cell: (row) => <span>{row.stageDescription}</span>,
        },

        {
          name: "Pipe line ID",

          selector: (row, i) => row.pipelineId,

          sortable: true,

          cell: (row) => <span>{row.pipelineId}</span>,
        },

        {
          name: "Stage FormId",

          selector: (row, i) => row.stageformId,

          sortable: true,

          cell: (row) => <span>{row.stageformId}</span>,
        },

        {
          name: "Stage Owners ",
          selector: (row, i) => row.stageowners,
          sortable: true,
          cell: (row) => <span>{row.stageowners}</span>,
        }, //***tableClms

        {
          name: "Actions",

          sortable: false,

          cell: (row) => (
            <div>
              {/* edit button and delete button */}

              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.LeadstageseditHandler(row)}
                className="bi bi-pen"
              ></Button>

              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,

      itemsPerPage: 10,

      isEditing: false,

      leadstages_Id: "",

      stageId: "",

      stageName: "",

      stageOrder: "",

      stageDescription: "",

      pipelineId: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

      stageformId: "",

      stageowners: "", //***state
    };
  }

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,

      stageId: "",

      stageName: "",

      stageOrder: "",

      stageDescription: "",

      pipelineId: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,

      isEditing: false,

      stageId: "",

      stageName: "",

      stageOrder: "",

      stageDescription: "",

      pipelineId: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",
    });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:
        toast.info(msg);
    }
  };

  LeadstageseditHandler = (row) => {
    // e.preventDefault();

    this.setState({
      isEditing: true,

      leadstages_Id: row.leadstages_Id,

      stageId: row.stageId,

      stageName: row.stageName,

      stageOrder: row.stageOrder,

      stageDescription: row.stageDescription,

      pipelineId: row.pipelineId,

      dummyOne: row.dummyOne,

      dummyTwo: row.dummyTwo,

      dummyThree: row.dummyThree,

      dummyFour: row.dummyFour,

      dummyFive: row.dummyFive,

      stageformId: row.stageformId,

      stageowners: row.stageowners, //***editstate
    });
  };

  LeadstagesfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Leadstages/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };

  LeadstagessubmitHandler = (e) => {
    e.preventDefault();

    //   setButtons(contacts);

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("stageId", this.state.stageId);

    formData.append("stageName", this.state.stageName);

    formData.append("stageOrder", this.state.stageOrder);

    formData.append("stageDescription", this.state.stageDescription);

    formData.append("pipelineId", this.state.pipelineId);

    formData.append("dummyOne", "");

    formData.append("dummyTwo", "");

    formData.append("dummyThree", "");

    formData.append("dummyFour", "");

    formData.append("dummyFive", "");

    formData.append("stageformId", this.state.stageformId);
    formData.append("stageowners", this.state.stageowners);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Leadstages/add", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadstagesfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            stageId: "",

            stageName: "",

            stageOrder: "",

            stageDescription: "",

            pipelineId: "",

            dummyOne: "",

            dummyTwo: "",

            dummyThree: "",

            dummyFour: "",

            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  LeadstagesupdateHandler = (e) => {
    e.preventDefault();

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("leadstages_Id", this.state.leadstages_Id);

    formData.append("stageId", this.state.stageId);

    formData.append("stageName", this.state.stageName);

    formData.append("stageOrder", this.state.stageOrder);

    formData.append("stageDescription", this.state.stageDescription);

    formData.append("pipelineId", this.state.pipelineId);

    formData.append("dummyOne", "");

    formData.append("dummyTwo", "");

    formData.append("dummyThree", "");

    formData.append("dummyFour", "");

    formData.append("dummyFive", "");

    formData.append("stageformId", this.state.stageformId);

    formData.append("stageowners", this.state.stageowners);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Leadstages/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadstagesfetchHandler();

          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.LeadstagesfetchHandler();

    //***componentDidMount
  }

  handlestageIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ stageId: fieldValue });
  };

  handlestageNameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ stageName: fieldValue });
  };

  handlestageOrderChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ stageOrder: fieldValue });
  };

  handlestageDescriptionChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ stageDescription: fieldValue });
  };

  handlepipelineIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ pipelineId: fieldValue });
  };

  handledummyOneChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyOne: fieldValue });
  };

  handledummyTwoChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyTwo: fieldValue });
  };

  handledummyThreeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyThree: fieldValue });
  };

  handledummyFourChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFour: fieldValue });
  };

  handledummyFiveChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFive: fieldValue });
  };

  handlestageformIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ stageformId: fieldValue });
  };

  handlestageownersChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ stageowners: fieldValue });
  }; //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);

    // implement your edit logic here
  };

  handleDelete = (row, index) => {
    var formData = new FormData();

    formData.append("leadstages_Id", row.leadstages_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Leadstages/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadstagesfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline







                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Lead Stages
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Leadstages</Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestageIdChange}
                                        className="form-control"
                                        name="stageId"
                                        value={this.state.stageId}
                                        required="required"
                                        placeholder="Enter Stage Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Name
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestageNameChange}
                                        className="form-control"
                                        name="stageName"
                                        value={this.state.stageName}
                                        required="required"
                                        placeholder="Enter Stage Name"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageName}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Order
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestageOrderChange}
                                        className="form-control"
                                        name="stageOrder"
                                        value={this.state.stageOrder}
                                        required="required"
                                        placeholder="Enter Stage Order"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageOrder}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Description
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlestageDescriptionChange
                                        }
                                        className="form-control"
                                        name="stageDescription"
                                        value={this.state.stageDescription}
                                        required="required"
                                        placeholder="Enter Stage Description"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageDescription}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pipe line ID
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepipelineIdChange}
                                        className="form-control"
                                        name="pipelineId"
                                        value={this.state.pipelineId}
                                        required="required"
                                        placeholder="Enter Pipe line ID"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.pipelineId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage FormId
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestageformIdChange}
                                        className="form-control"
                                        name="stageformId"
                                        value={this.state.stageformId}
                                        required="required"
                                        placeholder="Enter Stage FormId"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageformId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Owners
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestageownersChange}
                                        className="form-control"
                                        name="stageowners"
                                        value={this.state.stageowners}
                                        required="required"
                                        placeholder="Enter Stage Owners"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.stageowners}{" "}
                                    </div>
                                  </Row>

                                  <br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.LeadstagessubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {this.state.isEditing && (
                        // Edit Offcanvas

                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}

                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Leadstages</Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlestageIdChange}
                                          className="form-control"
                                          name="stageId"
                                          value={this.state.stageId}
                                          required="required"
                                          placeholder="Enter Stage Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.stageId}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Name
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlestageNameChange}
                                          className="form-control"
                                          name="stageName"
                                          value={this.state.stageName}
                                          required="required"
                                          placeholder="Enter Stage Name"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.stageName}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Order
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlestageOrderChange}
                                          className="form-control"
                                          name="stageOrder"
                                          value={this.state.stageOrder}
                                          required="required"
                                          placeholder="Enter Stage Order"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.stageOrder}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Description
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlestageDescriptionChange
                                          }
                                          className="form-control"
                                          name="stageDescription"
                                          value={this.state.stageDescription}
                                          required="required"
                                          placeholder="Enter Stage Description"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.stageDescription}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pipe line ID
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlepipelineIdChange}
                                          className="form-control"
                                          name="pipelineId"
                                          value={this.state.pipelineId}
                                          required="required"
                                          placeholder="Enter Pipe line ID"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.pipelineId}{" "}
                                      </div>
                                    </Row>
                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage FormId
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlestageformIdChange
                                          }
                                          className="form-control"
                                          name="stageformId"
                                          value={this.state.stageformId}
                                          required="required"
                                          placeholder="Enter Stage FormId"
                                        />
                                      </Col>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Owners{" "}
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlestageownersChange
                                          }
                                          className="form-control"
                                          name="stageowners"
                                          value={this.state.stageowners}
                                          required="required"
                                          placeholder="Enter Stage Owners "
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>

                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.LeadstagesupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />

                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
